<template>
  <div>
    <div class="row">
      <h4 class="col-12">Firman</h4>
      <LmSuperPowerSelectV2
        class="col-6"
        v-model="refrendaSelected"
        :urlPathFromGetOptions="optionsPath"
        label="Firmantes"
        placeholder="Firmantes"
        :multiple="true"
        :pageSize="20"
        :key="superPowerComponentKey"
        :itemsOrder="refrendaOrder"
      />
      <div class="col-6">
        <draggable
          tag="b-list-group"
          v-model="refrenda"
          @start="drag=true"
          @end="drag=false"
          >
            <b-list-group-item
              v-for="(item, index) in refrenda"
              :key="index"
              class="d-flex justify-content-between"
              >
              <font-awesome-icon class="bar mr-2" icon="bars" />
              {{ item.name }}
              <div class="d-flex justify-content-end align-items-center">
                <font-awesome-icon class="mr-2" icon="fingerprint"/>
                <b-badge variant="primary file-size">{{ index + 1 }}</b-badge>
                <!-- <font-awesome-icon class="close ml-3" icon="times" @click="deleteUploadFile(index)"/> -->
              </div>
            </b-list-group-item>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'

import draggable from 'vuedraggable'

export default {
  components: {
    LmSuperPowerSelectV2,
    draggable
  },
  data () {
    return {
      optionsPath: '/users/all',
      superPowerComponentKey: 0,
      refrendaSelected: '',
      refrenda: [],
      refrendaOrder: []
    }
  },
  watch: {
    refrendaSelected (val) {
      /*
        El evento @values del plugin vSelectPage no distingue el cambio
        de orden del array generando que vuedraggable no funcione
        Fix: uso variables independientes para que no cambie el orden en el
        super power cuando muevo el orden de los elementos.
      */
      this.refrenda = val
    },
    refrenda (val) {
      this.refrendaOrder = val.map(i => i.id)
      console.log('emito ', this.refrenda)
      this.$emit('input', this.refrenda)
    }
  }
}
</script>

<style>

</style>
